import BalloonView from "./BalloonView";

export default class NPCBalloonView extends BalloonView {

    constructor(target) {
        super(target);
    }

}
